import { useEffect, useState } from "react";
import { Button, Card, Spinner } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { siteDetail } from "../../../shared/settings/apiConfig";
import { getApi } from "../../../shared/services/apiHelper";
import { BuildingIcon, EditIcon } from "../../../shared/icons/Icons";
import './SiteDetail.scss';

export default function SiteDetail(props) {
    const history = useHistory();
    const siteId = props.match?.params?.id;

    const [loading, setLoading] = useState(true);
    const [siteData, setSiteData] = useState(null);

    useEffect(() => {
        if (siteId) {
            setLoading(true);
            getApi(`${siteDetail}/${siteId}`).then((response) => {
                setSiteData(response.data);
                setLoading(false);
            }).catch((error) => {
                console.error("Error fetching site details:", error);
                setLoading(false);
            });
        }
    }, [siteId]);

    const handleEdit = () => {
        history.push(`/sites/edit/${siteId}`);
    };

    const handleBack = () => {
        history.push('/sites');
    };

    if (loading) {
        return (
            <div className="d-flex align-items-center justify-content-center py-5 main-content">
                <div className="spinner-border text-purple" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    if (!siteData) {
        return (
            <div className="text-center py-5 main-content">
                <h4 className="text-muted">Site not found</h4>
                <Button className="secondary-btn-gradient mt-3" onClick={handleBack}>
                    Back to Sites
                </Button>
            </div>
        );
    }

    return (
        <div className="main-content site-detail-container animate-fade-in">
            {/* Header section */}
            <div className="site-header-section mb-4">
                <div className="mb-3">
                    <button 
                        className="back-link-text"
                        onClick={handleBack}
                    >
                        <i className="fa fa-arrow-left" style={{ marginRight: '8px' }}></i>
                        Back to Sites
                    </button>
                </div>

                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center gap-3">
                        <div className="p-3 rounded-circle d-flex align-items-center justify-content-center" 
                            style={{ backgroundColor: '#6b4ba1', width: '60px', height: '60px' }}>
                            <BuildingIcon color="#FFF" size={28} />
                        </div>
                        <div>
                            <h2 className="mb-1 fw-bold">{siteData.name}</h2>
                            <span className="text-muted">{siteData.location || ''}</span>
                        </div>
                    </div>
                    <div className="d-flex gap-2">
                        <Button 
                            className="btn-solid-blue d-flex align-items-center gap-2"
                            onClick={handleEdit}
                        >
                            <EditIcon color="#FFF" size={16} />
                            Edit Site
                        </Button>
                    </div>
                </div>
            </div>

            {/* Detail Card */}
            <Card className="border-0 rounded-4 p-4" style={{ boxShadow: "rgba(0, 0, 0, 0.1) 0px 2px 3px 0px, rgba(0, 0, 0, 0.1) 0px 1.5px 5px 0px" }}>
                <div className="row g-4">
                    <div className="col-lg-6">
                        <div className="mb-4">
                            <label className="text-muted small text-uppercase fw-semibold">Site Name</label>
                            <div className="fs-5 fw-medium mt-1">{siteData.name || '- - -'}</div>
                        </div>
                        <div className="mb-4">
                            <label className="text-muted small text-uppercase fw-semibold">Location</label>
                            <div className="fs-5 fw-medium mt-1">{siteData.location || '- - -'}</div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="mb-4">
                            <label className="text-muted small text-uppercase fw-semibold">Description</label>
                            <div className="fs-5 fw-medium mt-1">{siteData.description || '- - -'}</div>
                        </div>
                    </div>
                </div>
            </Card>
        </div>
    );
}